import { FormMessage } from './form-message.component';
import { FormTitle } from './form-title.component';
import logo from '../../../../assets/imgs/logoSecondaryPrimary.png';
import { RefObject } from 'react';
import { Transition } from '@headlessui/react';
import { FormSubtitle } from './form-subtitle.component';

export interface IFormMessageProps {
  error?: string | null;
  setError?: (error: string | null) => void;
  success?: string | null;
  setSuccess?: (success: string | null) => void;
}

interface IFormContainerProps extends React.PropsWithChildren, IFormMessageProps {
  contentRef?: RefObject<HTMLDivElement>;
  hideLogo?: boolean;
  id?: string;
  subtitle?: string;
  title: string;
}

export const FormContainer = ({
  children,
  contentRef,
  error,
  hideLogo,
  id,
  setError,
  setSuccess,
  subtitle,
  success,
  title
}: IFormContainerProps) => {
  return (
    <div
      className="flex min-h-full flex-1 flex-col items-center px-6 py-12 lg:px-8 overflow-auto"
      id={id}
      ref={contentRef}
    >
      {!hideLogo && (
        <div className="border-b border-b-gray-200 border-solid flex flex-row justify-center">
          <div className="flex flex-row items-end mb-4">
            <img className="h-16 w-64" src={logo} alt="Request IQ" />
          </div>
        </div>
      )}
      <div className="sm:mx-auto sm:w-full sm:max-w-4xl">
        <FormTitle spacing={subtitle ? 'sm' : 'md'} title={title} />
        {!!subtitle && <FormSubtitle text={subtitle} />}
        {children}
        <Transition
          appear={true}
          show={!!error}
          enter="transition-opacity duration-75"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <FormMessage
            type="error"
            onClose={() => {
              if (setError) setError(null);
            }}
          >
            {error}
          </FormMessage>
        </Transition>
        <Transition
          appear={true}
          show={!!success}
          enter="transition-opacity duration-75"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <FormMessage
            type="success"
            onClose={() => {
              if (setSuccess) setSuccess(null);
            }}
          >
            {success}
          </FormMessage>
        </Transition>
      </div>
    </div>
  );
};
